import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function queryByMid(mid) {
  return request({
    url: v2Host + '/dashboard/material/query',
    method: 'get',
    params: { mid: mid }
  })
}

export function queryPlaysmart(params) {
  return request({
    url: v2Host + '/dashboard/playsmart/materials',
    method: 'get',
    params
  })
}

export function fetchPtProjectStats(params) {
  return request({
    url: v2Host + '/dashboard/playturbo/project-stats',
    method: 'get',
    params: cookRequestParams(params)
  })
}
